import {
    GET_CATEGORIES,
    CREATE_CATEGORY,
    UPDATE_CATEGORY,
    DELETE_CATEGORY
} from '../actions/category';

const initialState = {
    categories: [],
    loading: false,
    error: null
};

const categoryReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case GET_CATEGORIES:
            return {
                ...state,
                categories: action.payload,
                loading: false
            };
        case CREATE_CATEGORY:
            return {
                ...state,
                categories: [...state.categories, action.payload],
                loading: false
            };
        case UPDATE_CATEGORY:
            return {
                ...state,
                categories: state.categories.map((category: any) =>
                    category._id === action.payload._id ? action.payload : category
                ),
                loading: false
            };
        case DELETE_CATEGORY:
            return {
                ...state,
                categories: state.categories.filter((category: any) => category._id !== action.payload),
                loading: false
            };
        default:
            return state;
    }
};

export default categoryReducer; 